module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibolditalic.92fefa88.ttf";